<div class="blacklist-dialog">
  <fieldset class="add-box">
    <legend>Adicionar CPF à blacklist</legend>
    <div class="add-row">
      <p-inputMask
        mask="999.999.999-99"
        placeholder="CPF"
        [(ngModel)]="newFederalId"
        styleClass="cpf"
      ></p-inputMask>
      <input
        type="text"
        pInputText
        placeholder="Nome (opcional)"
        [(ngModel)]="newName"
        maxlength="255"
      />
      <input
        type="text"
        pInputText
        placeholder="Motivo (opcional)"
        [(ngModel)]="newReason"
        maxlength="255"
        class="reason"
      />
      <button
        pButton
        type="button"
        icon="pi pi-ban"
        label="Bloquear"
        class="p-button-danger"
        (click)="add()"
      ></button>
    </div>
    <small>
      Bloqueia o CPF nesta marina mesmo sem cadastro de convidado. Se o convidado já tiver acesso
      liberado, o acesso é revogado e ele é removido da catraca.
    </small>
  </fieldset>

  <div class="search-row">
    <div class="p-inputgroup">
      <input
        type="text"
        pInputText
        placeholder="Buscar por CPF ou nome"
        [(ngModel)]="search"
        (keyup.enter)="load()"
      />
      <button pButton type="button" icon="pi pi-search" (click)="load()"></button>
      <button
        pButton
        type="button"
        label="Limpar"
        class="p-button-outlined"
        *ngIf="search"
        (click)="clearSearch()"
      ></button>
    </div>
  </div>

  <p-table
    [value]="entries"
    [loading]="loading"
    styleClass="easy-table"
    [paginator]="entries.length > 20"
    [rows]="20"
    [alwaysShowPaginator]="false"
  >
    <ng-template pTemplate="header">
      <tr>
        <th>CPF</th>
        <th>Nome</th>
        <th>Motivo</th>
        <th>Bloqueado por</th>
        <th class="text-center">Em</th>
        <th class="text-center"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-entry>
      <tr>
        <td>{{ entry.federalId }}</td>
        <td>{{ entry.name }}</td>
        <td>{{ entry.reason }}</td>
        <td>{{ entry.blockedByName }}</td>
        <td class="text-center">{{ entry.blockedAt | date : "dd/MM/yyyy HH:mm" }}</td>
        <td class="text-center">
          <button
            pButton
            type="button"
            icon="pi pi-unlock"
            label="Retirar"
            class="p-button-text p-button-sm"
            (click)="remove(entry)"
          ></button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="6" class="text-center">Nenhum CPF bloqueado nesta marina.</td>
      </tr>
    </ng-template>
  </p-table>

  <div class="buttons">
    <button pButton type="button" label="Fechar" class="p-button-outlined" (click)="close()"></button>
  </div>
</div>
